export function toURL(path: string) {
  if (path.startsWith('http') || path.startsWith('https')) {
    return path;
  } else {
    return [process.env.REACT_APP_PUBLIC_URL, path].join('/');
  }
}
